import React from 'react';

import { AddButtonPresentationalPropsType } from './types';

const AddButtonPresentational = ({ display, handleClick, month }: AddButtonPresentationalPropsType) => {
  return (
    <div
      onClick={handleClick}
      style={{
        background: '#006789',
        position: 'absolute',
        zIndex: 800,
        display: display ? undefined : 'none',
        height: '35px',
        width: '35px',
        fontSize: '25px',
        textAlign: 'center',
        bottom: month ? '10px' : '-50px',
        fontWeight: 500,
        right: '10px',
        color: 'white',
        cursor: 'pointer',
        boxShadow: '0px 0px 3px rgba(0,0,0,0.3)',
        fontFamily: 'Roboto'
      }}
      className="add-new-practice-button"
      id={display ? 'add-new-practice-button-visible' : ''}
    >
      +
    </div>
  );
};

export default AddButtonPresentational;